import { render } from "./SingleBook.vue?vue&type=template&id=221849b1&scoped=true"
import script from "./SingleBook.vue?vue&type=script&lang=js"
export * from "./SingleBook.vue?vue&type=script&lang=js"

import "./SingleBook.vue?vue&type=style&index=0&id=221849b1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221849b1"]])

export default __exports__